import { render, staticRenderFns } from "./DocsTramite.vue?vue&type=template&id=186703c8&"
import script from "./DocsTramite.vue?vue&type=script&lang=js&"
export * from "./DocsTramite.vue?vue&type=script&lang=js&"
import style0 from "./DocsTramite.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports